export default __webpack_public_path__ + "static/media/icon_directions_car.fb21e8c4.svg";